// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1123":"637c0728700903e1","2152":"b10d5e769091e5cd"}[chunkId] + ".css";
};